<template>
    <o-modal @showModal="showModal" @close="closeModal">
        <template v-slot:header>
            {{ computedTitle }}
        </template>
        <template v-slot:body>
            <o-form autocomplete="off">
                <div v-if="errors.length">
                    <div class="alert alert-danger">
                        <p>
                            <b>Please correct the following error(s):</b>
                            <ul>
                                <li v-for="(item, index) in errors" :key="index">{{ item }}</li>
                            </ul>
                        </p>
                    </div>
                </div>
                <o-form-group title="link" name="link" class="text-start mb-2">
                    <span class="text-danger"> *</span>
                    <textarea
                        name="link"
                        v-model="item.direct_link"
                        class="form-control"
                        rows="3"
                        style="resize: none; width: 100%;"
                        readonly
                    ></textarea>
                </o-form-group>
                <br>
                <div class="d-flex d-inline-block">
                    <div class="me-2">
                        <o-button 
                            @click="handleAction" 
                            :variant="'primary'" 
                            :white="'white'" 
                            type="submit"
                        >
                            {{ actionLabel }}
                        </o-button>
                    </div>
                    <div v-if="item.direct_link && !isGenerating" class="me-2">
                        <o-button 
                            @click="copyLink" 
                            :variant="'primary'" 
                            :white="'white'"
                        >
                            Copy
                        </o-button>
                    </div>
                </div>
            </o-form>
        </template>
    </o-modal>
</template>

<script>
import { OModal, OForm, OFormGroup, OButton } from '@/components/OmnihControl';
import { mapState } from 'vuex';


export default {
    name: 'AddDetail',
    components: {
        OModal,
        OForm,
        OFormGroup,

        OButton,
    },
    props: [
        'editedItem',
        'validationdetail',
    ],
    data() {
        return {
            item: {
                direct_link: '',
                title: 'New Generate Link Direct'
            },
            validationDetail: this.validationdetail,
            isModalVisible: false,
            errors: [],
            isGenerating: false,
        }
    },
    mounted() {
        if (Object.keys(this.editedItem).length !== 0) {
            this.item = { ...this.editedItem };
        }
    },
    methods: {
        showModal() {
            this.isModalVisible = true;
        },
        closeModal(e) {
            if (e && e.preventDefault) {
                e.preventDefault();
            }
            this.$emit('parentCloseModal');
        },
        handleAction() {
            this.errors = [];
            this.isGenerating = true;

            if (!this.item.direct_link) {
                const apiHost = process.env.VUE_APP_API_HOST;
                if (this.item.id) {
                    this.item.direct_link = `${apiHost}/login?corporate_id=${this.item.id}&dashboard=true`;
                } else {
                    this.errors.push('Corporate ID is required to generate the link.');
                }
                this.isGenerating = false;
                return;
            }

            if (this.item.direct_link === "") {
                this.errors.push('direct link required.');
            }

            if (this.errors.length === 0) {
                this.$emit('parentAddItem', this.item);
                this.isModalVisible = false;
                this.isGenerating = false;
            }
        },
        copyLink() {
            if (this.item.direct_link) {
                navigator.clipboard.writeText(this.item.direct_link)
                    .then(() => {
                        alert('Link copied to clipboard!');
                    })
                    .catch((err) => {
                        console.error('Failed to copy the link:', err);
                    });
            }
        }
    },
    computed: {
        ...mapState({}),
        computedTitle() {
            return this.item.direct_link ? 'Edit Generate Link Direct' : 'Create Generate Link Direct';
        },
        actionLabel() {
            return this.item.direct_link ? 'Save' : 'Generate';
        },
    },
}
</script>

<style>
.spinner {
    position: fixed;
    z-index: 3;
    top: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.5);
    height: 100%;
    width: 100%;
}
.spinner-position {
    display: block;
    position: fixed;
    z-index: 1031;
    top: 50%;
    right: 50%;
    margin-top: 5px;
    margin-left: 80px;
}
textarea.form-control {
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-word;
    resize: none; /* Prevent manual resizing */
}
</style>
